import React, { useRef } from "react";
import {
  User,
  Briefcase,
  Star,
  FolderKanban,
  GraduationCap,
  Award,
  Trophy,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";
import { Button } from "@/components/ui/button";

interface ProfileTabsProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

export default function ProfileTabs({
  activeTab,
  setActiveTab,
}: ProfileTabsProps) {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const tabs = [
    { id: "Personal", icon: User },
    { id: "Experience", icon: Briefcase },
    { id: "Skills", icon: Star },
    { id: "Projects", icon: FolderKanban },
    { id: "Education", icon: GraduationCap },
    { id: "Certifications", icon: Award },
    { id: "Awards", icon: Trophy },
  ];

  const handleWheel = (e: React.WheelEvent<HTMLDivElement>) => {
    if (scrollContainerRef.current) {
      if (e.deltaY !== 0) {
        scrollContainerRef.current.scrollLeft += e.deltaY;
      }
    }
  };

  const scroll = (direction: "left" | "right") => {
    if (scrollContainerRef.current) {
      const scrollAmount = 200;
      scrollContainerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="relative bg-white dark:bg-slate-900 rounded-2xl shadow-sm border border-slate-200 dark:border-slate-800 overflow-hidden group">
      {/* Scroll Left Button */}
      {/* <button
        type="button"
        onClick={() => scroll("left")}
        className="absolute left-1 top-1/2 -translate-y-1/2 z-10 p-1.5 rounded-full bg-white/90 dark:bg-slate-800/90 shadow-md border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:text-purple-700 dark:hover:text-purple-300 hover:bg-purple-50 dark:hover:bg-purple-950/40 transition-all opacity-0 group-hover:opacity-100 hidden sm:flex items-center justify-center"
        aria-label="Scroll left"
      >
        <ChevronLeft className="w-4 h-4" />
      </button> */}

      <div
        ref={scrollContainerRef}
        onWheel={handleWheel}
        className="flex overflow-x-auto scrollbar-thin scrollbar-thumb-slate-200 dark:scrollbar-thumb-slate-700 scroll-smooth"
      >
        {tabs.map((tab) => (
          <Button
            key={tab.id}
            variant="ghost"
            onClick={() => setActiveTab(tab.id)}
            className={`flex items-center gap-2 px-6 py-6 rounded-none text-sm font-semibold transition-colors whitespace-nowrap border-b-2 h-auto shrink-0 ${activeTab === tab.id
                ? "border-b-purple-700 dark:border-b-purple-500 text-purple-700 dark:text-purple-300 bg-purple-50/50 dark:bg-purple-950/30 hover:bg-purple-50/50 dark:hover:bg-purple-950/30"
                : "border-transparent text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800/50"
              }`}
          >
            <tab.icon
              className={`w-4 h-4 ${activeTab === tab.id ? "text-purple-700 dark:text-purple-400" : "text-slate-400 dark:text-slate-500"}`}
            />
            {tab.id}
          </Button>
        ))}
      </div>

      {/* Scroll Right Button */}
      {/* <button
        type="button"
        onClick={() => scroll("right")}
        className="absolute right-1 top-1/2 -translate-y-1/2 z-10 p-1.5 rounded-full bg-white/90 dark:bg-slate-800/90 shadow-md border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:text-purple-700 dark:hover:text-purple-300 hover:bg-purple-50 dark:hover:bg-purple-950/40 transition-all opacity-0 group-hover:opacity-100 hidden sm:flex items-center justify-center"
        aria-label="Scroll right"
      >
        <ChevronRight className="w-4 h-4" />
      </button> */}
    </div>
  );
}
